var chunkMapping = {
	"32": [
		3032
	],
	"686": [
		7686
	]
};
var idToExternalAndNameMapping = {
	"3032": [
		"default",
		"./components/CommonFooter",
		6547
	],
	"7686": [
		"default",
		"./components/CommonHeader",
		6547
	]
};
var idToRemoteMap = {
	"3032": [
		{
			"externalType": "script",
			"name": "fe_common"
		}
	],
	"7686": [
		{
			"externalType": "script",
			"name": "fe_common"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"3032": {
		"shareScope": "default",
		"name": "./components/CommonFooter",
		"externalModuleId": 6547,
		"remoteName": "fe_common"
	},
	"7686": {
		"shareScope": "default",
		"name": "./components/CommonHeader",
		"externalModuleId": 6547,
		"remoteName": "fe_common"
	}
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}